import { render, staticRenderFns } from "./preferenceTable.vue?vue&type=template&id=65d9f512&scoped=true"
import script from "./preferenceTable.vue?vue&type=script&lang=js"
export * from "./preferenceTable.vue?vue&type=script&lang=js"
import style0 from "./preferenceTable.vue?vue&type=style&index=0&id=65d9f512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d9f512",
  null
  
)

export default component.exports